var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { postNewGetSpecialPageByCon } from "../../request/designapi/design/special/newGetSpecialPageByCon/post.js";
async function checkSpecial(specialParams, checkParams) {
  var _a;
  const specialList = await postNewGetSpecialPageByCon(__spreadValues({
    pageSize: 500,
    pageNum: 1
  }, specialParams || {}));
  return (_a = specialList == null ? void 0 : specialList.records) == null ? void 0 : _a.some((item) => Object.keys(checkParams).every((key) => {
    const itemKey = key;
    const itemValue = item[itemKey];
    const checkValue = checkParams[itemKey];
    if (itemKey === "rosterValue") {
      return itemValue === "ALL" || itemValue === checkValue;
    }
    return itemValue === checkValue;
  }));
}
export { checkSpecial };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/checkSpecial/checkSpecial.js